//
//
//
//
//
import fullscreenmain from './components/FullScreenMain';
export default {
  components: {
    fullscreenmain: fullscreenmain
  }
};